
  import { defineComponent } from 'vue';
  
  export default defineComponent({
    name: 'About',
    title() {
      return 'Lennart Hakker - About';
    },
  });
